// utils
import { paramCase } from 'src/utils/change-case';
import { _id, _postTitles } from 'src/_mock/assets';

// ----------------------------------------------------------------------

const MOCK_ID = _id[1];

const MOCK_TITLE = _postTitles[2];

const ROOTS = {
  AUTH: '/auth',
  AUTH_DEMO: '/auth-demo',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  maintenance: '/maintenance',
  about: '/about-us',
  contact: '/contact-us',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
  docs: 'https://docs.minimals.cc',
  changelog: 'https://docs.minimals.cc/changelog',
  zoneUI: 'https://mui.com/store/items/zone-landing-page/',
  minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  freeUI: 'https://mui.com/store/items/minimal-dashboard-free/',
  figma:
    'https://www.figma.com/file/kAYnYYdib0aQPNKZpgJT6J/%5BPreview%5D-Minimal-Web.v5.0.0?type=design&node-id=0%3A1&t=Al4jScQq97Aly0Mn-1',
  quest: '/quest',
  games: '/games',
  vendors: '/vendors',
  lobbyblock: '/lobby-blocks',
  product: {
    root: `/product`,
    checkout: `/product/checkout`,
    details: (id: string) => `/product/${id}`,
    demo: {
      details: `/product/${MOCK_ID}`,
    },
  },
  // AUTH
  auth: {
    amplify: {
      login: `${ROOTS.AUTH}/amplify/login`,
      verify: `${ROOTS.AUTH}/amplify/verify`,
      register: `${ROOTS.AUTH}/amplify/register`,
      newPassword: `${ROOTS.AUTH}/amplify/new-password`,
      forgotPassword: `${ROOTS.AUTH}/amplify/forgot-password`,
    },
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      register: `${ROOTS.AUTH}/jwt/register`,
    },
    firebase: {
      login: `${ROOTS.AUTH}/firebase/login`,
      verify: `${ROOTS.AUTH}/firebase/verify`,
      register: `${ROOTS.AUTH}/firebase/register`,
      forgotPassword: `${ROOTS.AUTH}/firebase/forgot-password`,
    },
    auth0: {
      login: `${ROOTS.AUTH}/auth0/login`,
    },
  },
  authDemo: {
    classic: {
      login: `${ROOTS.AUTH_DEMO}/classic/login`,
      register: `${ROOTS.AUTH_DEMO}/classic/register`,
      forgotPassword: `${ROOTS.AUTH_DEMO}/classic/forgot-password`,
      newPassword: `${ROOTS.AUTH_DEMO}/classic/new-password`,
      verify: `${ROOTS.AUTH_DEMO}/classic/verify`,
    },
    modern: {
      login: `${ROOTS.AUTH_DEMO}/modern/login`,
      register: `${ROOTS.AUTH_DEMO}/modern/register`,
      forgotPassword: `${ROOTS.AUTH_DEMO}/modern/forgot-password`,
      newPassword: `${ROOTS.AUTH_DEMO}/modern/new-password`,
      verify: `${ROOTS.AUTH_DEMO}/modern/verify`,
    },
  },
  // OVERVIEW
  dashboard: {
    root: ROOTS.DASHBOARD,
    general: {
      ecommerce: `${ROOTS.DASHBOARD}/ecommerce`,
    },
    user: {
      root: `${ROOTS.DASHBOARD}/user`,
      new: `${ROOTS.DASHBOARD}/user/new`,
      list: `${ROOTS.DASHBOARD}/user/list`,
      cards: `${ROOTS.DASHBOARD}/user/cards`,
      profile: `${ROOTS.DASHBOARD}/user/profile`,
      account: `${ROOTS.DASHBOARD}/user/account`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/user/${id}/edit`,
      demo: {
        edit: `${ROOTS.DASHBOARD}/user/${MOCK_ID}/edit`,
      },
    },
    level: {
      root: `${ROOTS.DASHBOARD}/level`,
      new: `${ROOTS.DASHBOARD}/level/new`,
      list: `${ROOTS.DASHBOARD}/level/list`,
      cards: `${ROOTS.DASHBOARD}/level/cards`,
      profile: `${ROOTS.DASHBOARD}/level/profile`,
      account: `${ROOTS.DASHBOARD}/level/account`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/level/${id}/edit`,
      demo: {
        edit: `${ROOTS.DASHBOARD}/level/${MOCK_ID}/edit`,
      },
    },
    quest: {
      root: `${ROOTS.DASHBOARD}/quest`,
      new: `${ROOTS.DASHBOARD}/quest/new`,
      list: `${ROOTS.DASHBOARD}/quest/list`,
      cards: `${ROOTS.DASHBOARD}/quest/cards`,
      profile: `${ROOTS.DASHBOARD}/quest/profile`,
      account: `${ROOTS.DASHBOARD}/quest/account`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/quest/${id}/edit`,
      demo: {
        edit: `${ROOTS.DASHBOARD}/quest/${MOCK_ID}/edit`,
      },
    },
    games: {
      root: `${ROOTS.DASHBOARD}/games`,
      new: `${ROOTS.DASHBOARD}/games/new`,
      list: `${ROOTS.DASHBOARD}/games/list`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/games/${id}/edit`,
    },
    vendors: {
      root: `${ROOTS.DASHBOARD}/vendors`,
      new: `${ROOTS.DASHBOARD}/vendors/new`,
      list: `${ROOTS.DASHBOARD}/vendors/list`,
      edit: (id: number) => `${ROOTS.DASHBOARD}/vendors/${id}/edit`,
    },
    categories: {
      root: `${ROOTS.DASHBOARD}/categories`,
      new: `${ROOTS.DASHBOARD}/categories/new`,
      list: `${ROOTS.DASHBOARD}/categories/list`,
      edit: (id: number) => `${ROOTS.DASHBOARD}/categories/${id}/edit`,
    },
    lobbyBlocks: {
      root: `${ROOTS.DASHBOARD}/lobby-blocks`,
      new: `${ROOTS.DASHBOARD}/lobby-blocks/new`,
      list: `${ROOTS.DASHBOARD}/lobby-blocks/list`,
      edit: (id: number) => `${ROOTS.DASHBOARD}/lobby-blocks/${id}/edit`,
    },
    bonus: {
      root: `${ROOTS.DASHBOARD}/bonus`,
      new: `${ROOTS.DASHBOARD}/bonus/new`,
      list: `${ROOTS.DASHBOARD}/bonus/list`,
      edit: (id: number) => `${ROOTS.DASHBOARD}/bonus/${id}/edit`,
    },
  },
};
